import React from "react";

interface LinkGeneratedIconProps {
  className?: string;
}

const LinkGeneratedIcon: React.FC<LinkGeneratedIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      className={className}
    >
      <path
        d="M7.20798 26.6744C5.99034 25.4568 6.79769 22.8984 6.17828 21.4001C5.53504 19.8529 3.17651 18.5956 3.17651 16.9412C3.17651 15.2868 5.53504 14.0294 6.17828 12.4822C6.79769 10.9853 5.99034 8.42559 7.20798 7.20794C8.42563 5.99029 10.9853 6.79765 12.4822 6.17824C14.0361 5.535 15.2868 3.17647 16.9412 3.17647C18.5956 3.17647 19.853 5.535 21.4002 6.17824C22.8984 6.79765 25.4568 5.99029 26.6745 7.20794C27.8921 8.42559 27.0847 10.984 27.7042 12.4822C28.3474 14.036 30.7059 15.2868 30.7059 16.9412C30.7059 18.5956 28.3474 19.8529 27.7042 21.4001C27.0847 22.8984 27.8921 25.4568 26.6745 26.6744C25.4568 27.8921 22.8984 27.0847 21.4002 27.7041C19.853 28.3474 18.5956 30.7059 16.9412 30.7059C15.2868 30.7059 14.0295 28.3474 12.4822 27.7041C10.9853 27.0847 8.42563 27.8921 7.20798 26.6744Z"
        fill="#171C27"
        stroke="#171C27"
        strokeWidth="2.11765"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.647 18L14.8234 21.1765L22.2352 13.7647"
        stroke="white"
        strokeWidth="2.11765"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LinkGeneratedIcon;
